import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=b3021bfc&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=b3021bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3021bfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3021bfc')) {
      api.createRecord('b3021bfc', component.options)
    } else {
      api.reload('b3021bfc', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=b3021bfc&scoped=true&", function () {
      api.rerender('b3021bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27uD4Uvw1XjPY/JS/comp/DocBox.vue"
export default component.exports